import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/case-ticket/`;

const getCaseTickets = async (params = {}) => {
  return await axios.get(API_URL, { params });
};

const getCaseTicket = async (id) => {
  return await axios.get(API_URL + id);
};

// shop = the sidebar's selected shop: scopes the unclaimed count (backend).
const getActionableCounts = async (shop) => {
  return await axios.get(API_URL + "counts/actionable", { params: { shop } });
};

const createCaseTicket = async (payload) => {
  return await axios.post(API_URL, payload);
};

const getComments = async (id) => {
  return await axios.get(API_URL + id + "/comments");
};

// action: undefined = plain message (ขอข้อมูลเพิ่ม); 'accept' = supervisor's
// รับเรื่องแล้ว — moves the case to in_progress and arms the 2-day mark.
const addComment = async (id, message, action) => {
  return await axios.post(API_URL + id + "/comments", { message, ...(action && { action }) });
};

const waitCustomer = async (id) => {
  return await axios.put(API_URL + id + "/wait-customer");
};

const extendFollowUp = async (id) => {
  return await axios.put(API_URL + id + "/extend-follow-up");
};

const claimCaseTicket = async (id, takeover = false) => {
  return await axios.post(API_URL + id + "/claim", { takeover });
};

const releaseCaseTicket = async (id) => {
  return await axios.post(API_URL + id + "/release");
};

const customerUpdateCaseTicket = async (id, payload) => {
  return await axios.put(API_URL + id + "/customer-update", payload);
};

const confirmCustomer = async (id) => {
  return await axios.put(API_URL + id + "/confirm-customer");
};

const linkRefund = async (id, refundId) => {
  return await axios.put(API_URL + id + "/link-refund", { refundId });
};

const closeCaseTicket = async (id) => {
  return await axios.put(API_URL + id + "/close");
};

const reopenCaseTicket = async (id, status) => {
  return await axios.put(API_URL + id + "/reopen", { status });
};

const uploadAttachments = async (id, files, onProgress) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  return await axios.post(API_URL + id + "/attachments", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    ...(onProgress && {
      onUploadProgress: (e) => {
        if (e.total) onProgress(Math.round((e.loaded * 100) / e.total));
      },
    }),
  });
};

// ── ตามของ lane ──────────────────────────────────────────────────────────────
// The case-less lookup: every recent order of the customer, each with where the
// system thinks it is. Nothing is saved.
const quickCheck = async (customerId) => {
  return await axios.get(API_URL + "quick-check", { params: { customerId } });
};

// "I looked and there is no tracking number" — writes the canonical ไม่มีเลข
// placeholder onto the order, so the warehouse can hunt it by image + box name.
const markNoTracking = async (orderId) => {
  return await axios.post(API_URL + "no-tracking", { orderId });
};

const addItem = async (id, payload) => {
  return await axios.post(API_URL + id + "/items", payload);
};

const removeItem = async (id, itemId) => {
  return await axios.delete(API_URL + id + "/items/" + itemId);
};

const addChase = async (id, note) => {
  return await axios.post(API_URL + id + "/chases", { note });
};

// What Japan answered, per parcel: { "<itemId>": "found" | "not_found" }.
const warehouseResult = async (id, results, note) => {
  return await axios.post(API_URL + id + "/warehouse-result", { results, note });
};

// The supervisor's decision: what SHARE of the weight fee to waive per
// still-missing parcel (0 = none, 100 = free). The round and the deadline came
// from the admin at the warehouse step; the customer's message is drafted from
// both.
const setAssist = async (id, assists, extraNote) => {
  return await axios.post(API_URL + id + "/assist", { assists, extraNote });
};

// ตกหล่น compensation: { "<itemId>": percent } — 0 = ไม่ชดเชย, 100 = ฟรีค่าน้ำหนัก.
const setLapse = async (id, decisions) => {
  return await axios.post(API_URL + id + "/lapse", { decisions });
};

// The ตามของ weight-fee discount on each order — orderIds "1,2,3".
const getWeightAssists = async (orderIds) => {
  return await axios.get(API_URL + "weight-assist", { params: { orderIds } });
};

const CaseTicketService = {
  getCaseTickets,
  quickCheck,
  markNoTracking,
  addItem,
  removeItem,
  addChase,
  warehouseResult,
  setAssist,
  setLapse,
  getWeightAssists,
  getCaseTicket,
  getActionableCounts,
  createCaseTicket,
  getComments,
  addComment,
  waitCustomer,
  extendFollowUp,
  claimCaseTicket,
  releaseCaseTicket,
  customerUpdateCaseTicket,
  confirmCustomer,
  linkRefund,
  closeCaseTicket,
  reopenCaseTicket,
  uploadAttachments,
};

export default CaseTicketService;
